import styled from 'styled-components';

export const HeaderBox = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 30px 0;

  @media (max-width: 768px) {
    justify-content: flex-start;
    padding: 0 18px;
  }
`;
